import styled from 'styled-components';
import {
  px, pl, py, m, p, pr, my
} from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';
import theme from '@lib/theme';
import Grid from 'styled-components-grid';
import { colors } from '@components/ListItemFacility/styles';

export const StyledHeadlines = styled.div`
  font-size: 25px;
  font-weight: bold;
  line-height: 1.8rem;
  ${px(2)};
  ${py(3)};
  ${my(2)};
  ${breakpoint('mobile', 'desktop')`
  font-size: 20px;
  `}
`;

export const StyledTopImageGridWapper = styled.div`
  margin: 10% 0%;
  width: 100%;
  height: 400px;
  padding:10px;
  img {
    width: 100%;
    height: 100%;
    ${m(2)};
    border-radius: 8px;
    object-fit: fill;
    position: relative;
  }
  ${breakpoint('mobile', 'desktop')`
  height:300px;
  padding:0px;
  img {
    ${m(0)};
  }
  `}
`;

export const StyledDesktopPackages = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledPackages = styled(Grid)`
  width: 92%;
  display: flex;
  flex-wrap:nowrap;
  border-radius: 10px;
  justify-content: space-between;
  border: 1px solid #E2E8EA;
  @media (min-width:738px) and (max-width:800px){
      max-width: 700px;
  }
  @media (min-width:800px) and (max-width:1024px){
    max-width: 738px;
  }
  margin: 40px 20px;
  ${breakpoint('mobile', 'tablet')`
    margin:40px 0px;
    flex-direction: column;
    margin-top: 10px;
    padding:1%;
  `}
  ${breakpoint('tablet', 'desktop')`
    flex-direction: row;
    margin-top: 10px;
    padding:1%;
  `}
  ${breakpoint('mobile', 'desktop')`
    flex-direction:column;
  `}
`;

export const StyledFacilityCards = styled(Grid.Unit)`

  ${breakpoint('mobile', 'desktop')`
    display: flex;
    justify-content: center;

    svg{
    height: 60px;
    padding: 10px 0px;
    }

    img{
      height: 60px;
      padding: 10px 0px;
    }
  `}

${breakpoint('desktop')`
    svg{
      height: 45px;
       padding: 5px 0px;
    }

    img{
      height: 45px;
    padding: 5px 0px;
    }
    `}
  
`;

export const StyledCardItemsWrapper = styled.div`
  height: 100%;
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledFacilityCardsTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-width: 100%;
  align-items: center;
  justify-content: center;
  ${pl(1)};
  ${breakpoint('mobile', 'tablet')`
    font-size:12px;
    line-height:1.2rem;
    ${py(0)};
  `};
`;

export const StyledFacilityCardsTitle = styled.div`
  color: ${theme.colors.black};
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  padding: 5px 0px;
  ${breakpoint('mobile', 'tablet')`
    font-size:14px;
    line-height:1rem;
    ${py(0)};
  `};
`;


export const StyledFacilityCardsSubtitle = styled.div`
  color: ${({ color }) => color || 'black'};
  font-weight: 800;
  padding: 5px 0px;
  ${breakpoint('mobile', 'tablet')`
  font-size:14px;
`};
`;


export const StyledDesktopVisible = styled(Grid)`
  display: none;
  ${breakpoint('desktop')`
    display: block;
  `}
`;

export const StyledTitleSecond = styled.h2`
  color: ${theme.colors.darkGray};
  font-size: 25px;
  font-weight: bold;
  line-height: 1.4;
  ${breakpoint('mobile', 'tablet')`
    font-size: 28px;
    line-height: 2rem;
    ${py(2)};
  `};
`;

export const StyledLocationWrapper = styled.div`
  ${py(2)};
  display: flex;
  flex-direction: row;
  line-spacing: 1.2rem;
  ${breakpoint('mobile', 'desktop')`
    ${py(2)};
  `};
`;

export const StyledLocationIconWrapper = styled.div`
  ${pr(1)};

  svg {
    height: 15px;
    width: 25px;
  }
`;

export const StyledLocationText = styled.h3`
  color: ${theme.colors.navyGray};
  font-size:15px;
  font-weight: 600;
`;

export const StyledInfo = styled.div`
`;

export const StyledTopTextGridWapper = styled(Grid.Unit)`
  ${p(3)};
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  ${breakpoint('mobile', 'tablet')`
     ${p(1)};
  `};
`;

export const StyledFacilityCardsWrapperDesktopVisible = styled(Grid)`
   ${breakpoint('desktop')`
  display: flex;
    row-gap: 15px;
  `}
`;

export const StyledPriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  ${p(2)};
  align-items: center;
  justify-content: space-between;
  border-top: 2px solid ${colors.navyGray};
  border-bottom: 2px solid ${colors.navyGray};
  ${breakpoint('mobile', 'desktop')`
   ${py(3)};
   margin: 1rem 0;
`}
  ${breakpoint('desktop')`
  margin: 15px 0px;
  padding-right: 30px;
 
`}
`;

export const StyledPriceHeadline = styled.h3`
  font-weight: 700;
  text-align: left;
  font-size: 24px;

  ${breakpoint('tablet', 'desktop')`
   font-size: 26px;
  `}

  ${breakpoint('desktop')`
      font-size: 30px;
      font-weight: 800;
      color: ${colors.navyGray};
      padding: 0px;
  `}
`;

export const StyledSaveWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  svg {
    ${p(1)};
    width: 20px;
    height: 100%;
  }
  ${breakpoint('mobile', 'tablet')`
 row-gap: 5px;
`};

  ${breakpoint('desktop')`
  row-gap: 7px;
  flex-direction: column;
`}
`;

export const StyledAmountContent = styled.div`
  ${breakpoint('mobile', 'tablet')`
  ${pl(1)};
 `}

  ${breakpoint('desktop')`
   display: flex;
   align-items: center;
 `}
`;

export const StyledOldPrice = styled.span`
  font-size: 28px;
  font-weight: 600;
  color: ${theme.colors.red};
  text-decoration: line-through;

  ${breakpoint('mobile', 'tablet')`
  font-size:24px;
`};

  ${breakpoint('tablet', 'desktop')`
  font-size: 26px;
`}
`;

export const StyledSaveInfoContent = styled.span`
  color: ${colors.saveGreen};
  font-weight: 600;

  ${breakpoint('mobile', 'desktop')`
  font-size: 18px;
`}

  ${breakpoint('desktop')`
   font-size: 18px;
`}
`;

export const StyledPayNow = styled.span`
  font-size: 28px;
  margin-left: 10px;
  color: ${theme.colors.navyGray};
  font-weight: 600;
  ${breakpoint('mobile', 'tablet')`
  font-size:24px;
`};
  ${breakpoint('tablet', 'desktop')`
  font-size: 26px;
`}
`;

export const StyledBookButton = styled.button`
  color: ${theme.colors.white};
  width: 100%;
  font-size: 24px;
  cursor: pointer;
  :hover {
    filter: brightness(1.2);
  }
  transition: filter 0.3s ease;
  background-color: ${theme.colors.whitishGreen};
  border: none;
  border-radius: 8px;
  outline: none;
  font-weight: 600;
  margin: 0 auto;
  padding: 1rem 2rem;
  ${breakpoint('mobile', 'desktop')`
  ${py(3)};
  ${px(3)};
  margin: 1rem auto;
  font-size: 20px;
`};
`;

export const StyledBookText = styled.h3`
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  ${breakpoint('mobile', 'tablet')`
    font-size: 11px;
  `};
  ${breakpoint('desktop')`
    padding: 15px;
  `}
`;

export const CarouselControls = styled.div`
  display: ${props => (props.HideArrow === false ? 'none' : 'flex')};
  position: absolute;
  z-index: 1;
  left: 15px;
  right: 15px;
  justify-content: space-between;
  align-items: center;
  @media (min-width: 738px) and (max-width:880px){
    left: 0px;
    right: 0px;
  }
  ${breakpoint('mobile', 'tablet')`
    top: 100%;
  `}
`;

export const CarouselControl = styled.div`
  width: 30px;
  background: none;
  border: none;
  font-size: 24px;
  color: #000;
  cursor: pointer;
  img {
    height: 40px;
    padding: 10px;
    border-radius: 8px;
    ${({ hide }) =>
    hide
      && `
     opacity: 0.2;
     cursor: not-allowed;
    `};
  }
`;

export const StyledMobileVisible = styled(Grid)`
  display: block;
  ${breakpoint('desktop')`
  display: none;
 `}
`;

export const StyledTitleMain = styled.h1`
  color: ${theme.colors.darkGray};
  font-size: 38px;
  font-weight: bold;
  ${breakpoint('mobile', 'tablet')`
    font-size: 28px;
    line-height: 2rem;
    ${py(2)};
  `};
`;
